import { useTimezone } from '@app/core/hooks/useTimezone';
import { Station } from '@app/core/types/stations';
import { getAuditListingDefaultDateRange } from '@app/modules/audit/modules/station-audit/helpers/default-listing-date-range';
import { AuditSchedule } from '@mi-front/core';
import { apiClient } from '../../../../../../../../api';
import { ListingView } from '../../../../../../../../core/reports/components/ListingView';
import { ListingType } from '../../../../../../../../core/reports/types';
import {
  buildSchedulesListFilter,
  SchedulesListFilterValues,
  schedulesListMetadataDefaultValues,
} from '../../schedules-list-filter';
import { SchedulesListMentionsForm } from './SchedulesListMentionsForm';
import { SchedulesListMentionsResult } from './SchedulesListMentionsResult';

interface Props {
  readonly station: Station;
}

export type SchedulesMentionsListing = ListingType<SchedulesListFilterValues, AuditSchedule>;

export function SchedulesMentionsListView(p: Props) {
  const tz = useTimezone();

  return (
    <ListingView<SchedulesMentionsListing>
      defaultValues={{
        ...getAuditListingDefaultDateRange(tz),
        customId: '',
        ...schedulesListMetadataDefaultValues,
        sort: 'datetime desc',
      }}
      queryParamsTransform={{
        customId: {
          serialize: (input: string) => {
            return input.replace(/\s/g, '');
          },
        },
      }}
      reportFn={async (values) => {
        return apiClient.audit.fetchSchedules(p.station.slug, {
          ...values,
          page: values.pageIndex,
          filter: buildSchedulesListFilter(values, 'MENTION'),
          contain: 'mentionMatch',
        });
      }}
      Form={SchedulesListMentionsForm}
      Result={SchedulesListMentionsResult}
    />
  );
}
